// panel-wrapper.component.ts
import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
selector: 'outstanding-loans-field-group-wrapper',
template: `
 <div class="outstanding-loans-field-group-container" (mouseover)="onMouseOver($event)" (mouseleave)="onMouseLeave()">
 <div (click)="onClick()" class="icon-container">
   <mat-icon class="icon">clear</mat-icon>
 </div>
  <div><ng-container #fieldComponent></ng-container></div>
 </div>
`,
styles: [`
  .outstanding-loans-field-group-container {
    display: flex;
    justify-content: flex-start;
  }

  .icon-container {
    height: 50px;
    min-width: 29px;
    margin-right: 10px;
    cursor: pointer;
  }

  .icon {
    margin-top: 20px;
  }
`]
})
export class OutstandingLoansFieldGroupWrapperComponent extends FieldWrapper {
  hover = false;

  onMouseOver($event) {
    $event.stopPropagation();
    this.hover = true;
  }

  onMouseLeave() {
    this.hover = false;
  }

  onClick() {
    this.to.onClick(this.to.fieldGroupId);
  }
}
